var Wt = Object.defineProperty, $t = Object.defineProperties;
var zt = Object.getOwnPropertyDescriptors;
var Y = Object.getOwnPropertySymbols;
var Gt = Object.prototype.hasOwnProperty, qt = Object.prototype.propertyIsEnumerable;
var V = (t, e, a) => e in t ? Wt(t, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[e] = a, i = (t, e) => {
  for (var a in e || (e = {}))
    Gt.call(e, a) && V(t, a, e[a]);
  if (Y)
    for (var a of Y(e))
      qt.call(e, a) && V(t, a, e[a]);
  return t;
}, s = (t, e) => $t(t, zt(e));
import { LAYOUT_NODE_SHARED_CONTENT as j, CONTENT_NODE_NAVIGATION as X, CONTENT_NODE_LIST as K, CONTENT_NODE_BUTTON as J, CONTENT_NODE_FORM as Z, CONTENT_NODE_QUOTE as tt, CONTENT_NODE_TABLE as P, CONTENT_NODE_CARD as et, CONTENT_NODE_SEPARATOR as rt, CONTENT_NODE_SPACER as it, CONTENT_NODE_PANEL as st, CONTENT_NODE_ACCORDION as at, CONTENT_NODE_VIDEO as ot, CONTENT_NODE_CODE as nt, CONTENT_NODE_SLIDER as ct, CONTENT_NODE_GALLERY as pt, CONTENT_NODE_IMAGE as N, CONTENT_NODE_TEXT as D, CONTENT_NODE_HEADING as L, LAYOUT_NODE_FULL_WIDTH_COLUMN as lt, LAYOUT_NODE_RIGHT_SIDEBAR as gt, LAYOUT_NODE_LEFT_SIDEBAR as mt, LAYOUT_NODE_QUADRUPLE_COLUMN as ut, LAYOUT_NODE_TRIPLE_COLUMN as _t, LAYOUT_NODE_DOUBLE_COLUMN as ft, LAYOUT_NODE_SINGLE_COLUMN as ht, BASE_COLUMN as O, getBaseLayoutNode as y, getBaseContentNode as Q } from "@apptegy/page-builder";
const Tt = "ts-one-column", Ct = "ts-two-column", dt = "ts-three-column", Nt = "ts-four-column", S = "ts-full-width", bt = "ts-left-sidebar", It = "ts-right-sidebar", b = "pb-shared-content-block", Ot = "ts-heading", yt = "ts-text", Et = "ts-video", wt = "ts-embed", kt = "ts-slider", At = "ts-spacer", Pt = "ts-image", Dt = "ts-gallery", Lt = "ts-divider", St = "ts-accordion", Yt = "ts-table", vt = "ts-table-v2", Ut = "ts-button", xt = "ts-card", Rt = "ts-quote", Ft = "ts-form", Ht = "ts-list", Mt = "ts-navigation", te = (t, e) => {
  var l;
  const a = e || {};
  return [
    {
      id: t.id,
      name: t.name,
      component: t.type,
      properties: Bt(t),
      config: (l = t.nodes) == null ? void 0 : l.map((g) => [E(g, a)])
    }
  ];
}, E = (t, e) => {
  var a, l, g, _;
  switch (t.type) {
    case ht:
      return s(i({}, C(t, e)), {
        name: "One Column",
        component: Tt
      });
    case ft:
      return s(i({}, C(t, e)), {
        name: "2 Columns",
        component: Ct
      });
    case _t:
      return s(i({}, C(t, e)), {
        name: "3 Columns",
        component: dt
      });
    case ut:
      return s(i({}, C(t, e)), {
        name: "4 Columns",
        component: Nt
      });
    case mt:
      return s(i({}, C(t, e)), {
        name: "Left Sidebar",
        component: bt
      });
    case gt:
      return s(i({}, C(t, e)), {
        name: "Right Sidebar",
        component: It
      });
    case lt:
      return s(i({}, C(t, e)), {
        name: "Full Width",
        component: S
      });
    case L:
      return {
        id: t.id,
        name: "Headline",
        component: Ot,
        config: {
          blockId: t.id,
          content: t.content.html
        },
        properties: u(t),
        hasForm: !1
      };
    case D:
      return {
        id: t.id,
        name: "Text",
        component: yt,
        config: {
          blockId: t.id,
          content: t.content.html
        },
        properties: u(t),
        hasForm: !1
      };
    case N: {
      const n = {
        image: {
          // CONTENT
          url: (t == null ? void 0 : t.assetUrl) || ((a = t == null ? void 0 : t.content) == null ? void 0 : a.assetUrl) || ((l = e[t.content.assetId]) == null ? void 0 : l.url) || "",
          asset_id: t.content.assetId,
          alt_text: t.content.altText,
          caption: t.content.caption,
          link_url: t.content.link,
          // PROPERTIES
          set_ratio: t.properties.columnPercentage / 100,
          is_resized: t.properties.isResized,
          action_on_click: t.properties.actionOnClick,
          open_link_in_new_tab: t.properties.newTab,
          image_alignment: t.properties.imageAlignment,
          caption_alignment: t.properties.captionAlignment,
          show_caption: !!t.properties.showCaption,
          display: t.properties.resizeMode,
          cropped_width: t.properties.naturalWidth,
          cropped_height: t.properties.naturalHeight,
          preferred_width: t.properties.preferredWidth,
          preferred_height: t.properties.preferredHeight,
          decorative_image: t.properties.isDecorative,
          backgroundPosition: t.properties.backgroundPosition || "center",
          tilePercentage: t.properties.tilePercentage || 100
        }
      };
      return {
        id: t.id,
        name: "Image",
        component: Pt,
        config: n,
        properties: u(t),
        hasForm: !0
      };
    }
    case pt: {
      const n = {
        blockId: t.id,
        gallery: {
          images: t.content.images.map((r) => {
            var o, c;
            return {
              url: (r == null ? void 0 : r.assetUrl) || ((o = r == null ? void 0 : r.content) == null ? void 0 : o.assetUrl) || ((c = e[r.content.assetId]) == null ? void 0 : c.url) || "",
              // URL is not included in the new version
              sizes: {},
              // Sizes are not included in the new version
              alt_text: r.content.altText,
              asset_id: r.content.assetId,
              cropped_width: r.properties.naturalWidth,
              cropped_height: r.properties.naturalHeight,
              decorative_image: r.properties.isDecorative,
              caption: r.content.caption,
              focalPointPosition: r.properties.focalPointPosition
            };
          }),
          columns: t.properties.columnsCount,
          hasLightbox: t.properties.isLightbox,
          showCaptions: t.properties.showCaptions,
          captionsAlignment: t.properties.captionsAlignment
        }
      };
      return {
        id: t.id,
        name: "Gallery",
        config: n,
        properties: u(t),
        hasForm: !0,
        component: Dt
      };
    }
    case ct: {
      const n = {
        blockId: t.id,
        slider: {
          images: t.content.images.map((r) => {
            var o, c;
            return {
              url: (r == null ? void 0 : r.assetUrl) || ((o = r == null ? void 0 : r.content) == null ? void 0 : o.assetUrl) || ((c = e[r.content.assetId]) == null ? void 0 : c.url) || "",
              // URL is not included in the new version
              sizes: {},
              // Sizes are not included in the new version
              alt_text: r.content.altText,
              asset_id: r.content.assetId,
              caption: r.content.caption,
              link_url: r.content.link,
              action_on_click: r.properties.actionOnClick,
              open_link_in_new_tab: r.properties.newTab,
              decorative_image: r.properties.isDecorative,
              focalPointPosition: r.properties.focalPointPosition,
              cropped_height: r.properties.naturalHeight,
              // NEW
              cropped_width: r.properties.naturalWidth
              // NEW
            };
          }),
          has_dots: t.properties.showDots,
          dot_position: t.properties.dotsPosition,
          has_arrows: t.properties.showArrows,
          arrow_position: t.properties.arrowsPosition,
          is_autoplay: t.properties.isAutoplay,
          transition: t.properties.transitionSpeed
        }
      };
      return {
        id: t.id,
        name: "Slider",
        config: n,
        properties: u(t),
        hasForm: !0,
        component: kt
      };
    }
    case nt:
      return {
        id: t.id,
        name: "Code",
        component: wt,
        config: {
          blockId: t.id,
          embed: t.content.html,
          hasScriptTag: t.properties.hasScriptTag
        },
        properties: u(t),
        hasForm: !1
      };
    case ot:
      return {
        id: t.id,
        name: "Video",
        component: Et,
        config: {
          blockId: t.id,
          video: {
            url: t.content.embeddableUrl,
            isAutoplay: !1
          }
        },
        properties: u(t),
        hasForm: !0
      };
    case at:
      return {
        id: t.id,
        name: "Accordion",
        component: St,
        config: {
          blockId: t.id,
          accordion: {
            theme: t.properties.theme,
            icon_style: t.properties.iconStyle,
            allow_multiple_open_panels: t.properties.allowMultipleOpenPanels,
            items: t.nodes[0].nodes.map((n) => i({}, E(n, e)))
          }
        },
        properties: u(t),
        hasForm: !0
      };
    case st:
      return {
        id: t.id,
        text: t.properties.text,
        panelExpanded: t.properties.panelExpanded,
        content: t.nodes[0].nodes.map((n) => i({}, E(n, e))),
        properties: u(t)
      };
    case it:
      return {
        id: t.id,
        name: "Space",
        config: {
          blockId: t.id,
          spacer: {
            height: t.properties.height,
            backgroundColor: t.properties.backgroundColor || "#ffffff",
            isTransparent: t.properties.isTransparent || !1
          }
        },
        properties: u(t),
        hasForm: !0,
        component: At
      };
    case rt:
      return {
        id: t.id,
        name: "Separator",
        component: Lt,
        config: {
          blockId: t.id,
          divider: {
            thickness: t.properties.thickness,
            style: "solid",
            width: t.properties.width,
            color: { hex: t.properties.color }
          }
        },
        properties: u(t),
        hasForm: !0
      };
    case et: {
      const { heading: n, text: r, image: o } = t.content, c = {
        blockId: t.id,
        card: {
          headline: n.content.html,
          content: r.content.html,
          image: {
            url: (o == null ? void 0 : o.assetUrl) || ((g = o == null ? void 0 : o.content) == null ? void 0 : g.assetUrl) || ((_ = e[o.content.assetId]) == null ? void 0 : _.url) || "",
            alt_text: o.content.altText,
            asset_id: o.content.assetId,
            decorative_image: o.properties.isDecorative,
            focalPointPosition: o.properties.focalPointPosition,
            cropped_height: o.properties.naturalHeight,
            // NEW
            cropped_width: o.properties.naturalWidth,
            // NEW
            sizes: {}
            // Sizes are not included in the new version
          },
          design: t.properties.design,
          hasImage: t.properties.showImage,
          hasHeadline: t.properties.showHeadline,
          imageRight: t.properties.imagePosition === "right",
          wrapText: t.properties.wrapText
        }
      };
      return {
        id: t.id,
        name: "Card",
        component: xt,
        config: c,
        properties: u(t),
        hasForm: !0
      };
    }
    case P:
      return {
        id: t.id,
        name: "Table",
        component: vt,
        config: {
          table: {
            content: t.content.html,
            theme: t.properties.theme,
            alternatingColors: t.properties.alternatingColors
          },
          blockId: t.id
        },
        properties: u(t),
        hasForm: !0
      };
    case tt:
      return {
        id: t.id,
        name: "Quote",
        component: Rt,
        config: {
          blockId: t.id,
          quote: {
            content: t.content.quote,
            author: t.content.author,
            source: t.content.source,
            design: t.properties.design,
            color: {
              hex: t.properties.color
            }
          }
        },
        properties: u(t),
        hasForm: !0
      };
    case Z: {
      const n = t.content.formId == null ? {} : {
        blockId: t.id,
        form: {
          form_id: t.content.formId,
          show_one_question_at_time: t.properties.showOneQuestionAtATime
        }
      };
      return {
        id: t.id,
        name: "Form",
        component: Ft,
        config: n,
        properties: u(t),
        hasForm: !0
      };
    }
    case J: {
      const n = {
        button: {
          // Properties
          size: t.properties.size,
          type: t.properties.type,
          theme: t.properties.theme,
          alignment: t.properties.alignment,
          pill: t.properties.pillShape,
          style: t.properties.style,
          has_icons: t.properties.hasIcons,
          // Content
          buttons: t.content.buttons.map((r) => s(i(i({
            title: r.title,
            link: r.link,
            open_link_in_new_tab: r.newTab
          }, r.icon ? { icon: r.icon } : {}), r.iconId ? { icon_id: r.iconId } : {}), {
            mailto: r.mailto
          }))
        },
        blockId: t.id
      };
      return {
        id: t.id,
        name: "Button",
        config: n,
        properties: u(t),
        hasForm: !0,
        component: Ut
      };
    }
    case K:
      return {
        id: t.id,
        name: "List",
        config: {
          list: {
            items: [...t.content.items],
            design: t.properties.design,
            format: t.properties.format
          },
          blockId: t.id
        },
        properties: u(t),
        hasForm: !0,
        component: Ht
      };
    case X:
      return {
        id: t.id,
        name: "Navigation",
        config: {
          selectedPageId: t.content.selectedPageId,
          selectedChildrenIds: t.content.selectedChildrenIds,
          design: t.properties.design,
          color: t.properties.color
        },
        hasForm: !0,
        component: Mt
      };
    case j:
      return {
        id: t.id,
        name: b,
        config: {
          id: t.id,
          name: b,
          type: b,
          sharedContentId: `${t.sharedContentId}`,
          properties: t.properties
        },
        hasForm: !0,
        component: b
      };
    default:
      return console.error("Unhandled node type: ", t), t;
  }
}, C = (t, e) => ({
  id: t.id,
  properties: Bt(t),
  config: Vt(t, e),
  hasForm: !1
}), u = (t) => {
  var e, a;
  return {
    anchorTag: ((e = t.properties) == null ? void 0 : e.anchorTag) || "",
    customClasses: ((a = t.properties) == null ? void 0 : a.customClasses) || []
  };
}, Vt = (t, e) => t.nodes ? t.nodes.map((l) => {
  var g;
  return ((g = l.nodes) == null ? void 0 : g.map((_) => E(_, e))) || l;
}) : t, Bt = (t) => {
  var e, a, l;
  return s(i({}, t.properties), {
    borderRadius: s(i({}, t.properties.borderRadius), {
      value: Number((e = t.properties.borderRadius) == null ? void 0 : e.value) || 0
    }),
    padding: s(i({}, t.properties.padding), {
      value: Number((a = t.properties.padding) == null ? void 0 : a.value) || 0
    }),
    margin: s(i({}, t.properties.margin), {
      value: Number((l = t.properties.margin) == null ? void 0 : l.value) || 0
    }),
    backgroundColor: s(i({}, t.properties.backgroundColor), {
      value: t.properties.backgroundColor.value || ""
    }),
    backgroundImage: s(i({}, t.properties.backgroundImage), {
      image: t.properties.backgroundImage.image || null
    })
  });
}, Qt = (t) => {
  const { header: e, matrix: a, orientation: l, textAlign: g, bold: _ } = i({ header: [] }, t), n = (o) => {
    const c = o == null ? "<p></p>" : o;
    if (g !== "center")
      return c;
    const f = /<p>/, T = /<p style=".*">/;
    return c.match(f) ? c.replace("<p>", `<p style="text-align: ${g};">`) : c.match(T) ? c.match(T)[0].includes("text-align:") ? c : c.replace('<p style="', `<p style="text-align: ${g};`) : c;
  }, r = ["<table>"];
  if (l === "horizontal")
    if (_) {
      const o = a.map((c, f) => ["<tr>", `<th scope="row">${n(e[f].value)}</th>`, ...c.map((T) => `<td>${n(T.value)}</td>`), "</tr>"].join(""));
      r.push(...o);
    } else {
      const o = a.map((c, f) => ["<tr>", `<td>${n(e[f].value)}</td>`, ...c.map((T) => `<td>${n(T.value)}</td>`), "</tr>"].join(""));
      r.push(...o);
    }
  else {
    if (e.length > 0)
      if (_) {
        const c = e.map((f) => `<th scope="col">${n(f.value)}</th>`);
        r.push("<tr>", ...c, "</tr>");
      } else {
        const c = e.map((f) => `<td>${n(f.value)}</td>`);
        r.push("<tr>", ...c, "</tr>");
      }
    const o = a.map((c) => ["<tr>", ...c.map((f) => `<td>${n(f.value)}</td>`), "</tr>"].join(""));
    r.push(...o);
  }
  return r.push("</table>"), r.join("");
};
let w;
const ee = (t) => {
  var _, n;
  w = {};
  let e = [];
  ((_ = t[0]) == null ? void 0 : _.id) === "root" ? e = t[0].config.flat() : e = t;
  const a = e.map((r) => v(r)), l = ((n = t[0]) == null ? void 0 : n.properties) || {
    backgroundColor: {
      toggle: !1,
      value: ""
    },
    backgroundImage: {
      toggle: !1,
      image: null
    }
  };
  return {
    structure: {
      id: "root",
      name: "Root",
      type: O,
      properties: l,
      nodes: a
    },
    assets: w
  };
}, jt = ({ component: t }) => {
  const e = t === S;
  return {
    borderRadius: {
      value: 0
    },
    backgroundColor: {
      toggle: !1,
      value: ""
    },
    backgroundImage: {
      toggle: !1,
      image: null
    },
    margin: {
      linked: !e,
      value: 10,
      top: 10,
      bottom: 10,
      left: e ? 0 : 10,
      right: e ? 0 : 10
    },
    padding: {
      linked: !0,
      value: 0,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    },
    customClasses: [],
    anchorTag: ""
  };
}, v = (t) => {
  var e, a, l, g, _, n, r, o, c, f, T, k, U, x, R, F, H, M, B, W, $, z, G, q;
  switch (t == null ? void 0 : t.component) {
    case Tt:
      return s(i({}, d(t)), {
        name: "One Column",
        type: ht
      });
    case Ct:
      return s(i({}, d(t)), {
        name: "Two Columns",
        type: ft
      });
    case dt:
      return s(i({}, d(t)), {
        name: "Three Columns",
        type: _t
      });
    case Nt:
      return s(i({}, d(t)), {
        name: "Four Columns",
        type: ut
      });
    case bt:
      return s(i({}, d(t)), {
        name: "Left Sidebar",
        type: mt
      });
    case It:
      return s(i({}, d(t)), {
        name: "Right Sidebar",
        type: gt
      });
    case S:
      return s(i({}, d(t)), {
        name: "Full Width",
        type: lt
      });
    case Ot:
      return {
        id: t.id,
        name: "Heading",
        type: L,
        content: {
          html: t.config.content
        },
        properties: m(t)
      };
    case yt:
      return {
        id: t.id,
        name: "Text",
        type: D,
        content: {
          html: t.config.content
        },
        properties: m(t)
      };
    case At:
      return {
        id: t.id,
        name: "Spacer",
        type: it,
        properties: s(i({}, m(t)), {
          height: t.config.spacer.height,
          backgroundColor: t.config.spacer.backgroundColor || "#ffffff",
          isTransparent: t.config.spacer.isTransparent || !1
        })
      };
    case Lt:
      return {
        id: t.id,
        name: "Separator",
        type: rt,
        properties: s(i(i({}, m(t)), t.config.divider), {
          color: (e = t.config.divider.color) == null ? void 0 : e.hex,
          style: ((a = t.config.divider) == null ? void 0 : a.style) || "solid"
        })
      };
    case wt:
      return {
        id: t.id,
        name: "Code",
        type: nt,
        content: {
          html: t.config.embed
        },
        properties: s(i({}, m(t)), {
          hasScriptTag: t.config.hasScriptTag
        })
      };
    case Et:
      return {
        id: t.id,
        name: "Video",
        type: ot,
        content: {
          rawUrl: "",
          embeddableUrl: t.config.video.url,
          isResized: !1,
          videoAlignment: "center",
          width: "100%"
        },
        properties: m(t)
      };
    case Rt:
      return {
        id: t.id,
        name: "Quote",
        type: tt,
        content: {
          quote: t.config.quote.content,
          author: t.config.quote.author,
          source: t.config.quote.source
        },
        properties: s(i({}, m(t)), {
          design: t.config.quote.design,
          color: t.config.quote.color.hex
        })
      };
    case Pt:
      return I((g = (l = t == null ? void 0 : t.config) == null ? void 0 : l.image) == null ? void 0 : g.asset_id, (n = (_ = t == null ? void 0 : t.config) == null ? void 0 : _.image) == null ? void 0 : n.url), {
        id: t.id,
        name: "Image",
        type: N,
        assetUrl: ((o = (r = t == null ? void 0 : t.config) == null ? void 0 : r.image) == null ? void 0 : o.url) || "",
        content: {
          assetUrl: ((f = (c = t == null ? void 0 : t.config) == null ? void 0 : c.image) == null ? void 0 : f.url) || "",
          assetId: t.config.image.asset_id,
          altText: t.config.image.alt_text,
          caption: t.config.image.caption,
          link: t.config.image.link_url
        },
        properties: s(i({}, m(t)), {
          actionOnClick: t.config.image.action_on_click,
          newTab: t.config.image.open_link_in_new_tab,
          imageAlignment: t.config.image.image_alignment,
          captionAlignment: t.config.image.caption_alignment,
          columnPercentage: t.config.image.set_ratio * 100,
          isResized: !!t.config.image.is_resized,
          resizeMode: t.config.image.display,
          showCaption: !!t.config.image.show_caption,
          isDecorative: t.config.image.decorative_image,
          naturalWidth: t.config.image.cropped_width,
          naturalHeight: t.config.image.cropped_height,
          preferredWidth: t.config.image.preferred_width,
          preferredHeight: t.config.image.preferred_height
        })
      };
    case Dt: {
      const h = t.config.gallery.images.map((p) => (I(p.asset_id, p.url), {
        name: "Image",
        type: N,
        assetUrl: p.url,
        content: {
          assetUrl: p.url,
          assetId: p.asset_id,
          altText: p.alt_text,
          caption: p.caption || ""
          // New
        },
        properties: s(i({}, m(t)), {
          isDecorative: p.decorative_image,
          naturalWidth: p.cropped_width,
          naturalHeight: p.cropped_height,
          focalPointPosition: p.focalPointPosition || {
            // New
            x: 50,
            y: 50
          }
        })
      }));
      return {
        id: t.id,
        name: "Gallery",
        type: pt,
        content: {
          images: h
        },
        properties: s(i({}, m(t)), {
          columnsCount: t.config.gallery.columns,
          isLightbox: t.config.gallery.hasLightbox,
          showCaptions: t.config.gallery.showCaptions || !1,
          // New
          captionsAlignment: t.config.gallery.captionsAlignment || "center"
          // New
        })
      };
    }
    case kt: {
      const h = t.config.slider.images.map((p) => (I(p.asset_id, p.url), {
        name: "Image",
        type: N,
        assetUrl: p.url,
        content: {
          assetUrl: p.url,
          assetId: p.asset_id,
          altText: p.alt_text,
          caption: p.caption || "",
          // New
          link: p.link_url || ""
        },
        properties: s(i({}, m(t)), {
          actionOnClick: p.action_on_click,
          newTab: p.open_link_in_new_tab,
          isDecorative: p.decorative_image,
          naturalWidth: p.cropped_width || 0,
          // New
          naturalHeight: p.cropped_height || 0,
          // New
          focalPointPosition: p.focalPointPosition || {
            // New
            x: 50,
            y: 50
          }
        })
      }));
      return {
        id: t.id,
        name: "Slider",
        type: ct,
        content: {
          images: h
        },
        properties: s(i({}, m(t)), {
          showDots: t.config.slider.has_dots,
          dotsPosition: t.config.slider.dot_position === "bottom" ? "below" : t.config.slider.dot_position,
          showArrows: t.config.slider.has_arrows,
          arrowsPosition: t.config.slider.arrow_position,
          isAutoplay: t.config.slider.is_autoplay,
          transitionSpeed: t.config.slider.transition
        })
      };
    }
    case Ut:
      return {
        id: t.id,
        name: "Button",
        type: J,
        content: {
          buttons: t.config.button.buttons.map((h) => ({
            title: h.title,
            link: h.link,
            newTab: h.open_link_in_new_tab || !1,
            mailto: h.mailto || !1,
            icon: h.icon || null,
            iconId: h.icon_id || null
          }))
        },
        properties: s(i({}, m(t)), {
          type: t.config.button.type,
          theme: t.config.button.theme,
          size: t.config.button.size,
          pillShape: !!t.config.button.pill,
          alignment: t.config.button.alignment,
          style: t.config.button.style || "1",
          hasIcons: !!t.config.button.has_icons
        })
      };
    case xt:
      return I((U = (k = (T = t == null ? void 0 : t.config) == null ? void 0 : T.card) == null ? void 0 : k.image) == null ? void 0 : U.asset_id, (F = (R = (x = t == null ? void 0 : t.config) == null ? void 0 : x.card) == null ? void 0 : R.image) == null ? void 0 : F.url), {
        id: t.id,
        name: "Card",
        type: et,
        content: {
          heading: Q({
            id: `cardTitle_${t.id}`,
            type: L,
            content: { html: t.config.card.headline }
          }),
          text: Q({
            id: `cardContent_${t.id}`,
            type: D,
            content: { html: t.config.card.content }
          }),
          image: {
            name: "Image",
            type: N,
            assetUrl: ((B = (M = (H = t == null ? void 0 : t.config) == null ? void 0 : H.card) == null ? void 0 : M.image) == null ? void 0 : B.url) || "",
            content: {
              assetUrl: ((z = ($ = (W = t == null ? void 0 : t.config) == null ? void 0 : W.card) == null ? void 0 : $.image) == null ? void 0 : z.url) || "",
              assetId: t.config.card.image.asset_id,
              altText: t.config.card.image.alt_text
            },
            properties: {
              isDecorative: t.config.card.image.decorative_image,
              naturalWidth: t.config.card.image.cropped_width || 0,
              // New
              naturalHeight: t.config.card.image.cropped_height || 0,
              // New
              focalPointPosition: t.config.card.image.focalPointPosition || {
                // New
                x: 50,
                y: 50
              }
            }
          }
        },
        properties: s(i({}, m(t)), {
          design: t.config.card.design,
          showImage: t.config.card.hasImage,
          showHeadline: t.config.card.hasHeadline,
          imagePosition: t.config.card.imageRight ? "right" : "left",
          wrapText: t.config.card.wrapText
        })
      };
    case Ft:
      return {
        id: t.id,
        name: "Form",
        type: Z,
        content: {
          formId: ((G = t.config.form) == null ? void 0 : G.form_id) || null
        },
        properties: s(i({}, m(t)), {
          showOneQuestionAtATime: ((q = t.config.form) == null ? void 0 : q.show_one_question_at_time) || !1
        })
      };
    case Yt:
      return {
        id: t.id,
        name: "Table",
        type: P,
        content: {
          html: Qt(t.config.table)
        },
        properties: s(i({}, m(t)), {
          theme: "default",
          alternatingColors: !1
        })
      };
    case vt:
      return {
        id: t.id,
        name: "Table",
        type: P,
        content: {
          html: t.config.table.content
        },
        properties: s(i({}, m(t)), {
          theme: t.config.table.theme,
          alternatingColors: t.config.table.alternatingColors
        })
      };
    case St: {
      const h = t.config.accordion.icon_style === "minus" ? "plus" : t.config.accordion.icon_style, p = {
        id: t.id,
        name: "Accordion",
        type: at,
        properties: s(i({}, m(t)), {
          theme: t.config.accordion.theme,
          iconStyle: h,
          allowMultipleOpenPanels: t.config.accordion.allow_multiple_open_panels
        }),
        nodes: [
          s(i({}, y({ type: O })), {
            nodes: t.config.accordion.items.map((A) => Xt(A))
          })
        ]
      };
      return p.nodes[0].nodes.map((A) => A.parentAccordionId = p.id), p;
    }
    case Ht:
      return {
        id: t.id,
        name: "List",
        type: K,
        content: {
          items: [...t.config.list.items]
        },
        properties: s(i({}, m(t)), {
          design: t.config.list.design,
          format: t.config.list.format
        })
      };
    case Mt:
      return {
        id: t.id,
        name: "Navigation",
        type: X,
        content: {
          selectedPageId: t.config.selectedPageId,
          selectedChildrenIds: t.config.selectedChildrenIds
        },
        properties: {
          design: t.config.design,
          color: t.config.color
        }
      };
    case b:
      return {
        id: t.id,
        name: "Shared content",
        type: j,
        sharedContentId: t.config.sharedContentId,
        properties: t.config.properties,
        nodes: [
          i({}, y({ type: O }))
        ]
      };
    default:
      return console.error("Unhandled node type: ", t), t;
  }
}, Xt = (t) => ({
  id: t.id,
  name: "Accordion Panel",
  type: st,
  properties: s(i({}, m(t)), {
    text: t.text,
    panelExpanded: t.panelExpanded
  }),
  nodes: [
    s(i({}, y({ type: O })), {
      nodes: t.content.map((e) => v(e))
    })
  ]
}), I = (t, e) => {
  w = s(i({}, w), {
    [t]: {
      url: e
    }
  });
}, d = (t) => {
  var a, l, g, _, n, r, o, c;
  (g = (l = (a = t.properties) == null ? void 0 : a.backgroundImage) == null ? void 0 : l.image) != null && g.content && I(
    (r = (n = (_ = t.properties.backgroundImage) == null ? void 0 : _.image) == null ? void 0 : n.content) == null ? void 0 : r.assetId,
    (c = (o = t.properties.backgroundImage) == null ? void 0 : o.image) == null ? void 0 : c.assetUrl
  );
  const e = i({
    customClasses: [],
    anchorTag: ""
  }, t.properties || jt(t));
  return {
    id: t.id,
    properties: e,
    nodes: Kt(t)
  };
}, m = (t) => {
  var e, a;
  return {
    anchorTag: ((e = t.properties) == null ? void 0 : e.anchorTag) || "",
    customClasses: ((a = t.properties) == null ? void 0 : a.customClasses) || []
  };
}, Kt = (t) => t.config ? t.config.map((a) => {
  const l = a.map((g) => v(g));
  return s(i({}, y({ type: O })), {
    nodes: l
  });
}).flat() : [];
export {
  ee as convertLegacyPageConfigToPageBuilderConfig,
  te as convertPageBuilderConfigToLegacyPageConfig,
  Qt as convertTableToV2
};
